import axios from '../BASE_API'
import AuthHeader from '../AuthHeader'
import { LeadStatusPost, LeadStatusUpdate } from '../../app/models/SuperAdminLeadStatus'

class LeadStatusService {

  getLeadStatusList = () => {
    return axios.get('/lead-status/list', { headers: AuthHeader() })
  }

  addLeadStatus = (data: LeadStatusPost) => {
    return axios.post('/lead-status/add', data, { headers: AuthHeader() })
  }

  updateLeadStatus = (data: LeadStatusUpdate) => {
    return axios.put('/lead-status/update', data, { headers: AuthHeader() })
  }
 
  deleteLeadStatus = (id: number) => {
    return axios.delete(`/lead-status/delete`, {
      data: {
        id: id.toString(),
      },
      headers: AuthHeader(),
    })
  }

  changeLeadStatus = (id: number) => {
    return axios.put(`/lead-status/change-status`, { id: id }, { headers: AuthHeader() })
  }

}

export default new LeadStatusService()
